export default async function BulkCreateTasksApi(planId, tasks) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ planId, tasks }),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/bulk-create`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error bulk creating tasks: ", error);
        res = { success: false, message: "Error creating tasks" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: "Error creating tasks" };
  }

  return res;
}
